<app-authorized-guard
  [authorized]="!unauthorized_delete"
  message="You are not authorized to delete this user."
></app-authorized-guard>

<app-loading-guard [loading]="loading$ | async">
  <div *ngIf="item$ | async as item">
    <mat-dialog-content>
      <div class="header">
        <h3 class="title">User Details</h3>
        <button mat-icon-button mat-dialog-close>
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="detail">
        <span class="label">Name</span>
        <span class="value">{{ item.name }}</span>
      </div>
      <div class="detail">
        <span class="label">User Type</span>
        <span class="value">{{ getUserFriendlyType(item) }}</span>
      </div>
      <div class="detail">
        <span class="label">Email Address</span>
        <span class="value">{{ item.email }}</span>
      </div>
      <div class="detail">
        <span class="label">Location Access</span>
        <span class="value" *ngFor="let location of item.locations">{{
          location.name
        }}</span>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="form-buttons">
      <a mat-button mat-dialog-close color="primary">Close</a>
      <div class="actions">
        <a mat-button [mat-dialog-close]="'delete'" color="primary">Delete</a>
        <button
          mat-raised-button
          rippleOnHover
          color="primary"
          [disabled]="pending"
          [mat-dialog-close]="'edit'"
        >
          Edit User
        </button>
      </div>
    </mat-dialog-actions>
  </div>
</app-loading-guard>
